module.exports = __webpack_public_path__ + "img/zhonggu2.1299ef4c.jpg";